// extracted by mini-css-extract-plugin
export default {"label":"Label_label__QpDEH","success":"Label_success__O2M-5"};